// extracted by mini-css-extract-plugin
module.exports = {"payment":"payment_payment__Sh5eO","pay":"payment_pay__v1FbR","paymentForm":"payment_paymentForm__3drk9","payButton":"payment_payButton__1bNwM","cancel":"payment_cancel__2Dpn8"};